import { createStyles } from "antd-style";

export const usePaystandCheckoutStyles = createStyles(({ css }: any) => ({
  root: css`
    position: relative;
    margin-inline: -24px;
  `,
  paystandFrame: css`
    width: 100%;
    min-height: 480px;

    iframe {
      border: none;
      width: 100%;
      min-height: 480px;
    }
  `,
}));
